// extracted by mini-css-extract-plugin
module.exports = {"scores":"score_scores__2YUyx","set":"score_set__byntB"};